import OneSignal from "react-onesignal";
import { logger } from "../utils/logger";

const ONESIGNAL_APP_ID = process.env.REACT_APP_ONESIGNAL_APP_ID || "0155aef6-36d6-49b7-8e26-741250e9ae3c";

let initialized = false;

export const initializeOneSignal = async () => {
  if (initialized || typeof window === "undefined") return;
  try {
    await OneSignal.init({
      appId: ONESIGNAL_APP_ID,
      notifyButton: { enable: false },
      allowLocalhostAsSecureOrigin: true,
    });
    initialized = true;
    // OneSignal ready
  } catch (err) {
    logger.error("OneSignal init failed:", err);
  }
};

export const promptForNotifications = async () => {
  try {
    await OneSignal.Notifications.requestPermission(true);
  } catch (err) {
    logger.error("OneSignal permission request failed:", err);
  }
};

export const loginOneSignal = async (userId) => {
  try {
    await OneSignal.login(userId);
  } catch (err) {
    logger.error("OneSignal login failed:", err);
  }
};

export const logoutOneSignal = async () => {
  try {
    await OneSignal.logout();
  } catch (err) {
    logger.error("OneSignal logout failed:", err);
  }
};
